import React from 'react';
import {storage} from './firebase';
import {getDownloadURL, ref, uploadBytesResumable} from 'firebase/storage';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowLeft} from '@fortawesome/free-solid-svg-icons';
import './admin.css';
import {CircularProgressbar} from 'react-circular-progressbar';
import axios from '../axios.js';
import {faEdit,faTrashAlt,faMapMarkerAlt
} from '@fortawesome/free-solid-svg-icons';
import ProgressBar from "@ramonak/react-progress-bar";

class AdminPanel extends React.Component {

    constructor(props) {
      super(props);
      this.state = {
        progress : 0 ,
        isLoading: false,
        fileUrl : '',
       fileType: '',
       service : '',
       location:'',
       AllData : [],
       isError : false,
       isUpload :  false,
      }
    
     this.changeHandler  = this.changeHandler.bind(this);
     this.submitHandler = this.submitHandler.bind(this);
    //  this.fileUploads = this.fileUploads.bind(this)
    }
    
     changeHandler = (e) => {
       const name = e.target.name;
       const value = e.target.value;
       this.setState({
         [name] : value
       })
    } 
    fetchData = () => {
      this.setState({isLoading:true});
      axios.get("/api/file")
      .then(data =>{
        this.setState({AllData:data.data})
        console.log(data.data)
        this.setState({isLoading:false})
      })
      .catch(err => {
        console.log(err)
      this.setState({isLoading:false})
      this.setState({isError:true})
    }
      )
    
    }
    componentDidMount(){
      this.fetchData()
    }

    deleteHandler = async (e) => {
        
      let params = window.location.search
      const id = new URLSearchParams(params).get('id');
      
      //// delete the  task

     await axios.delete(`/api/file/${id}`)
          .then(res =>{
            console.log(res.data)
             this.fetchData()
           })
          .catch(err => {
            console.log(err)
           this.setState({isError:true});
           setTimeout(()=>{
             this.setState({isError:false})
           },5000) 
          })
          
       
       
      }



    submitHandler = (e) => {
       e.preventDefault();
       const file = e.target[0].files[0]
       
       this.setState({isUpload:true});
        
       if(!file)  return;
        console.log("i got it",file)
       const storageRef = ref(storage,`file/${file.name}`);
       const uploadTask = uploadBytesResumable(storageRef, file);
       uploadTask.on("state_changed",(snapshot) => {
           const prog = Math.round((snapshot.bytesTransferred/snapshot.totalBytes) * 100);

           this.setState({progress : prog});
       },(err)=> console.log(err), 
       ()=>{
         getDownloadURL(uploadTask.snapshot.ref).then(url =>{
          
          console.log(url)
          this.setState({fileUrl: url})
          this.setState({fileType : file.type})
           console.log(this.state.fileType,this.state.fileUrl,this.state.service,this.state.location) ;

             axios.post('/api/file',{Location:this.state.location, Service:this.state.service, FileUrl:this.state.fileUrl, FileType:this.state.fileType})
             .then(data => {
               console.log(data)
               this.fetchData()
               this.setState({isUpload:false})
               setTimeout(()=>{
           this.setState({progress : 0});
               },8000)
            })
             .catch(err =>{ 
               console.log(err)
           this.setState({isUpload:false})
          });
          })
         
       });


  }


render(){
  return (
    <div>
       <h2 className='text-center auth_heading'>SPS LAND PROMOTERS</h2>
     <h3 style={{marginBottom:'20px'}} className="text-center">
       Admin Panel
       </h3> 
    <div style={{display:'flex', justifyContent:'space-between'}}>

     <div>
       <FontAwesomeIcon 
        icon={faArrowLeft} 
        onClick={()=> window.open("/","_self")}
        className="arrow_left_admin"/> <span style={{fontSize:'1.2rem', fontWeight:'bold', color:'darkgray'}}>Back to Home </span>  
     </div>
     <div className=''>
         <button style={{fontSize:'1.1rem'}} className="btn btn-sm btn-primary m-3" onClick={()=>window.open("https://analytics.google.com/analytics/web/?authuser=6#/p302918527/reports/reportinghub","_self")}>View Analytics</button>
     </div>
    </div>
       <h4 className='text-center m-2' style={{marginBottom:'8px'}}>Upload Video and Images..</h4>
       <form onSubmit={this.submitHandler} className="form_page">
     <div className="form-group" >

       <label Htmlfor="file">Image or Video : </label>
       <input type="file" className="form-control-file"
       name="file" id="image_file" placeholder="Images"
        onChange={this.changeHandler}
       aria-describedby="fileHelpId"
       required={true}
       accept='.jpeg, .jpg, .png, .mp4'/>
     </div>
     <div className="form-group">
       <label Htmlfor="service">Service Type: </label>
       <select className="form-control"
       value={this.state.service}
       name= "service"
       required={true}
        id="" onChange={this.changeHandler}>
         <option>Plots and Approvals</option>
         <option>Consturction </option>
         <option>Road Work</option>
         <option>2d,3d plans</option>
         <option></option>
       </select>
     </div>
     <div className="form-group">
       <label Htmlfor="">Location : </label>
       <input type="text" 
       required={true}
       value={this.state.location}
       className="form-control" name="location" id="location" aria-describedby="helpId" placeholder="Enter the place of project" onChange={this.changeHandler} />
       
     </div>
  <button type='submit' className='btn btn-primary m-2' disabled={this.state.isUpload} >{this.state.isUpload ? "Loading.." : "Submit"}</button>
       </form>
       <ProgressBar
       bgColor='#ec3c3c'
       completed={this.state.progress} 
       ariaValuetext={`uploaded ${this.state.progress}%`}
       className="file_upload_progressbar" />
     <h6 className='text-center'>{this.state.isLoading ?  "Loading...":""}</h6>
    <h6 className='text-center text-danger '>{this.state.isError ? "something went wrong please try again later....": ""}</h6>
     <div className="admin_image_row"> 
     {
       this.state.AllData.map((data) => {
        let params = window.location.search              
        const currentId = new URLSearchParams(params).get('id');

    return   <div className='admin_image_column'  key={data._id}>            
            <div>
               <a href={`/admin-panel?id=${data._id}`}
       
        data-image={data._id}
        className="images_container_link " 
        style={{textDecoration:'none'}}>
                 <FontAwesomeIcon icon={faTrashAlt} className="image_delete_icon" />
                 </a>
               {currentId === data._id ? <div className='delete_warning'>
                 do you want to delete ? <button className="cancel_button " onClick={()=> window.open("/admin-panel","_self")}>cancel</button>
                 <button className='yes_button' onClick={this.deleteHandler}>yes</button>
               </div> : ''}
             </div>
           <div  className="">{
              data.FileType === "video/mp4" ? <video src={data.FileUrl} controls  className="admin_panel_images"></video> :
              <img src={data.FileUrl} alt={data.Service} className="admin_panel_images"></img>}
              <div>
               <div style={{display:'flex',gap:'10px'}}>
               <FontAwesomeIcon icon={faMapMarkerAlt} />
                <h6>{data.Location}</h6>
               </div>
                <h6>{data.Service}</h6>
              </div>
         </div>
         </div>

       })
     }
      </div>

  </div>
  )
}

}
export default AdminPanel